import type {
  SmartReportComponentTypesEnum,
  SmartReportLayoutIdsEnum,
  SmartReportTypeEnum,
} from '@/admins/SmartReports/types';

export const SLOT = 'SLOT';

export type LayoutDefinition<
  ComponentProps = unknown,
  ComponentViewProps = unknown,
  ThumbnailProps = unknown,
> = {
  id: SmartReportLayoutIdsEnum;
  title: string;
  description: string;
  Component: React.ComponentType<ComponentProps>;
  ComponentView: React.ComponentType<ComponentViewProps>;
  Thumbnail: React.ComponentType<ThumbnailProps>;
  elementTypes: SmartReportComponentTypesEnum[];
  reportTypes?: SmartReportTypeEnum[];
};
